import {
  VoiceScanReport,
  VoiceScanReportDetailErrorResponse,
  VoiceScanReportDetailResponse,
} from 'services/voice-scan/type';

export function encodeWAV(audioBuffer: AudioBuffer): Blob {
  const numChannels = audioBuffer.numberOfChannels;
  const sampleRate = audioBuffer.sampleRate;
  const samples = audioBuffer.length;
  const buffer = new ArrayBuffer(44 + samples * numChannels * 2);
  const view = new DataView(buffer);

  function writeString(view: DataView, offset: number, str: string) {
    for (let i = 0; i < str.length; i++) {
      view.setUint8(offset + i, str.charCodeAt(i));
    }
  }

  let offset = 0;
  writeString(view, offset, 'RIFF');
  offset += 4;
  view.setUint32(offset, 36 + samples * numChannels * 2, true);
  offset += 4;
  writeString(view, offset, 'WAVE');
  offset += 4;
  writeString(view, offset, 'fmt ');
  offset += 4;
  view.setUint32(offset, 16, true);
  offset += 4;
  view.setUint16(offset, 1, true);
  offset += 2;
  view.setUint16(offset, numChannels, true);
  offset += 2;
  view.setUint32(offset, sampleRate, true);
  offset += 4;
  view.setUint32(offset, sampleRate * numChannels * 2, true);
  offset += 4;
  view.setUint16(offset, numChannels * 2, true);
  offset += 2;
  view.setUint16(offset, 16, true);
  offset += 2;
  writeString(view, offset, 'data');
  offset += 4;
  view.setUint32(offset, samples * numChannels * 2, true);
  offset += 4;

  const interleaved = new Float32Array(samples * numChannels);
  for (let ch = 0; ch < numChannels; ch++) {
    audioBuffer.getChannelData(ch).forEach((sample, i) => {
      interleaved[i * numChannels + ch] = sample;
    });
  }

  let index = offset;
  for (let i = 0; i < interleaved.length; i++, index += 2) {
    const s = Math.max(-1, Math.min(1, interleaved[i]));
    view.setInt16(index, s < 0 ? s * 0x8000 : s * 0x7fff, true);
  }

  return new Blob([view], { type: 'audio/wav' });
}

export function isVoiceScanReport(
  data: VoiceScanReportDetailResponse | undefined
): data is VoiceScanReport {
  return (data as VoiceScanReport)?.voice_scan_report !== undefined;
}

export function isVoiceScanReportDetailError(
  data: VoiceScanReportDetailResponse | undefined
): data is VoiceScanReportDetailErrorResponse {
  return (data as VoiceScanReportDetailErrorResponse)?.error === true;
}
